import React from 'react'
import PropTypes from 'prop-types'
import { Panel, Margin, Text, Form, FormInput, Button } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { BottomNavigation } from '../../public/events/overview/components/bottomNavigation'

import * as styles from './styles'

const PersonalInfoComponent = ({
	loggedEntity,
	form,
	onSubmit,
	initialValues
}) => {
	const history = useHistory()

	const handleBackClick = () => {
		history.push('/profile')
	}

	if (!loggedEntity) {
		return (
			<>
				{/* Mobile Header */}
				<div css={styles.mobileHeader}>
					<div css={styles.headerContainer}>
						<FontAwesomeIcon
							icon="arrow-left"
							css={styles.backArrow}
							onClick={handleBackClick}
						/>
						<div css={styles.titleContainer}>
							<Text size={16} bold css={styles.headerTitle}>
								Personal Information
							</Text>
						</div>
					</div>
				</div>

				<Panel css={styles.panel}>
					<div css={styles.contentWrapper}>
						<Text>Loading...</Text>
					</div>
				</Panel>

				<BottomNavigation />
			</>
		)
	}

	return (
		<>
			{/* Mobile Header */}
			<div css={styles.mobileHeader}>
				<div css={styles.headerContainer}>
					<FontAwesomeIcon
						icon="arrow-left"
						css={styles.backArrow}
						onClick={handleBackClick}
					/>
					<div css={styles.titleContainer}>
						<Text size={16} bold css={styles.headerTitle}>
							Personal Information
						</Text>
					</div>
				</div>
			</div>

			<Panel as={Form} form={form} onSubmit={onSubmit} css={styles.panel}>
				<div css={styles.contentWrapper}>
					<Margin bottom={5} css={styles.title}>
						<Text as="h1" size={18} bold>
							Personal Information
						</Text>
					</Margin>

					<div css={styles.pageWrapper}>
						<div css={styles.formContent}>
							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Email</Text>
								<FormInput name="email" placeholder="Email address" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>First Name</Text>
								<FormInput name="firstName" placeholder="First name" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Last Name</Text>
								<FormInput name="lastName" placeholder="Last name" />
							</Margin>

							<Margin tb={1} css={styles.row}>
								<Text as="label" size={11}>Nickname</Text>
								<FormInput name="nickName" placeholder="Nickname" />
							</Margin>

							<Margin bottom={2} top={3}>
								<Button medium css={styles.saveButton}>
									<Text css={styles.buttonText}>Save changes</Text>
								</Button>
							</Margin>
						</div>
					</div>
				</div>
			</Panel>

			<BottomNavigation />
		</>
	)
}

PersonalInfoComponent.propTypes = {
	loggedEntity: PropTypes.shape(),
	form: PropTypes.shape().isRequired,
	onSubmit: PropTypes.func.isRequired,
	initialValues: PropTypes.shape(),
}

export default PersonalInfoComponent 